import { useState, useEffect } from 'react';
import {
  Dialog,
  Button,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';

export const ConsentModal = () => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpen(!localStorage.getItem('consent'));
  }, []);

  const onAccept = () => {
    setOpen(false);
    localStorage.setItem('consent', '1');
  };

  return (
    <Dialog
      open={open}
      maxWidth="lg"
      disableRestoreFocus
      aria-labelledby="consent-dialog-title"
      aria-describedby="consent-dialog-description"
    >
      <DialogTitle id="consent-dialog-title" sx={{ fontWeight: 600 }}>
        DOD NOTICE AND CONSENT BANNER
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          You are accessing a U.S. Government (USG) Information System (IS)
          that is provided for USG-authorized use only.
        </DialogContentText>
        <DialogContentText sx={{ mt: 2 }}>
          By using this IS (which includes any device attached to this IS),
          you consent to the following conditions:
        </DialogContentText>
        <DialogContentText sx={{ mt: 2 }}>
          - The USG routinely intercepts and monitors communications on this IS
          for purposes including, but not limited to, penetration testing,
          COMSEC monitoring, network operations and defense, personnel
          misconduct (PM), law enforcement (LE), and counterintelligence (CI)
          investigations.
        </DialogContentText>
        <DialogContentText sx={{ mt: 1 }}>
          - At any time, the USG may inspect and seize data stored on this IS.
        </DialogContentText>
        <DialogContentText sx={{ mt: 1 }}>
          - Communications using, or data stored on, this IS are not private,
          are subject to routine monitoring, interception, and search, and may
          be disclosed or used for any USG-authorized purpose.
        </DialogContentText>
        <DialogContentText sx={{ mt: 1 }}>
          - This IS includes security measures (e.g., authentication and access
          controls) to protect USG interests--not for your personal benefit or
          privacy.
        </DialogContentText>
        <DialogContentText sx={{ mt: 1 }}>
          - Notwithstanding the above, using this IS does not constitute consent
          to PM, LE or CI investigative searching or monitoring of the content
          of privileged communications, or work product, related to personal
          representation or services by attorneys, psychotherapists, or clergy,
          and their assistants. Such communications and work product are private
          and confidential.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onAccept}
          variant="contained"
          color="primary"
          autoFocus
          size="large"
        >
          ACCEPT
        </Button>
      </DialogActions>
    </Dialog>
  );
};
